import { useAuth } from '@clerk/clerk-react';
import { getStoredGuestSessionToken } from '@/utils/guestSession';

/**
 * True for a code-redemption guest, false for a signed-in Clerk user (or
 * while Clerk is still loading). Same precedence as useSessionToken: a
 * stored guest token is only ever authoritative once Clerk has confirmed
 * nobody's signed in, so a real Clerk session always wins.
 */
export const useIsGuest = (): boolean => {
  const { isLoaded, isSignedIn } = useAuth();
  return isLoaded && !isSignedIn && !!getStoredGuestSessionToken();
};

export default useIsGuest;
